import { IModalOpenerProps } from '@cian/frontend-newbuilding-broker-component';
import { Button } from '@cian/ui-kit';
import * as React from 'react';

export const NewbuildingBrokerBannerButton: React.VFC<IModalOpenerProps> = ({ onClick }) => (
  <Button onClick={onClick}>Хочу продать</Button>
);
